import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CommonResponse, processNormal } from '../common/response.model';
import { ErrorHandlingService } from '../common/error-handling.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorVerifiedService {
  private verifiedData$: Observable<any> | null = null;

  constructor(
    private http: HttpClient,
    private errorHandling: ErrorHandlingService
  ) { }

  getDoctorVerified(forceRefresh = false): Observable<any> {
    // Si ya tenemos los datos y no se fuerza la recarga, devolvemos el cache
    if (!forceRefresh && this.verifiedData$) {
      return this.verifiedData$;
    }

    this.verifiedData$ = this.http.get<CommonResponse<any>>(
      environment.apiUrl + 'doctor_verified'
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors),
      shareReplay(1) // Cachea la respuesta para futuras suscripciones
    );

    return this.verifiedData$;
  }
}